import type { ComponentPropsWithoutRef } from 'react';

interface FullSizeViewportProps extends ComponentPropsWithoutRef<'div'> {}

export function FullSizeViewport({ className, ...props }: FullSizeViewportProps) {
  return (
    <div
      className={['tw-h-full tw-w-full tw-min-h-0 tw-min-w-0 tw-overflow-x-hidden tw-overflow-y-auto', className]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
}
